import get from 'lodash/get';
import type { Permissions } from '@/Interfaces/Data';
import type { DotNestedKeys } from '@/_types/utils';
import { useAppSelector } from '@/_store/hooks';
import { selectUser } from '@/_store/modules/auth/selectors';

function useCheckPermissions(
  ...permissionToCheck: DotNestedKeys<Permissions>[]
) {
  const user = useAppSelector(selectUser);

  return permissionToCheck.some(
    permission => get(user?.permissions, permission) || false,
  );
}

export default useCheckPermissions;
